import React, { useRef, useEffect, useState } from "react";
import "./SignatureCanvas.css";

function SignatureCanvas({
  onSign,
  onCancel,
  title = "Firma del Cliente de Porte",
  signLabel = "Firmar Carta de Porte",
}) {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      // Establecer el tamaño del canvas
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      
      // Asignar tamaño físico al canvas
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;

      // Escalar el contexto para el DPR
      const ctx = canvas.getContext("2d");
      ctx.scale(dpr, dpr);
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.lineWidth = 2;
      ctx.strokeStyle = "#000";
      
      console.log("Canvas initialized - CSS size:", rect.width, "x", rect.height, "DPR:", dpr);
    }
  }, []);

  const getCoordinates = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    
    let clientX, clientY;
    if (e.touches) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    } else {
      clientX = e.clientX;
      clientY = e.clientY;
    }
    
    // Calcular posición relativa al canvas (el contexto ya está escalado)
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    
    return { x, y };
  };

  const startDrawing = (e) => {
    e.preventDefault();
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { x, y } = getCoordinates(e);

    setIsDrawing(true);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    
    e.preventDefault(); // Prevenir scroll en dispositivos táctiles

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const { x, y } = getCoordinates(e);

    ctx.lineTo(x, y);
    ctx.stroke();
    setIsEmpty(false);
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    ctx.clearRect(0, 0, rect.width, rect.height);
    setIsEmpty(true);
  };

  const handleSign = () => {
    const canvas = canvasRef.current;
    if (isEmpty) {
      alert("Por favor, dibuja tu firma");
      return;
    }

    // Convertir canvas a base64
    const imageData = canvas.toDataURL("image/png");
    onSign(imageData);
  };

  return (
    <div className="signature-canvas-container">
      <div className="signature-header">
        <h3>{title}</h3>
        <p className="instruction">Dibuja tu firma con el ratón o dedo</p>
      </div>

      <canvas
        ref={canvasRef}
        className="signature-canvas"
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={stopDrawing}
        onMouseLeave={stopDrawing}
        onTouchStart={startDrawing}
        onTouchMove={draw}
        onTouchEnd={stopDrawing}
      />

      <div className="signature-actions">
        <button className="btn-clear" onClick={clearCanvas}>
          Limpiar
        </button>
        <div className="btn-group-right">
          <button className="btn-cancel" onClick={onCancel}>
            Cancelar
          </button>
          <button className="btn-sign" onClick={handleSign} disabled={isEmpty}>
            {signLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignatureCanvas;
